import i18n from '@/localisation/i18n';
import ImageCropper from '@/widgets/PhotoCropper';
import { ImageControls } from './ImageControls';

export const AvatarEdit = () => {
  return (
    <>
      <div className="my-3 flex flex-col justify-between md:my-5 lg:flex-row lg:items-center">
        <div>
          <div className="text-base text-additional">{i18n.t('photo')}*</div>
          <div className="text-xs text-additional">{i18n.t('will.shown')}</div>
        </div>
        <div className="mt-3 flex items-center lg:mt-0">
          <ImageControls />
          <ImageCropper />
        </div>
      </div>
      <div className="divider"></div>
    </>
  );
};
